// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import defaultReducer from "./slices/DefaultSlice";
import referralsReducer from "./slices/ReferralsSlice";
import vendorReducer from "./slices/VendorSlice";
import referralpaymentsReducer from "./slices/ReferralpaymentsSlice";
import disputesReducer from "./slices/DisputesSlice";
import waitlistReducer from "./slices/WaitlistSlice";
import faqsReducer from "./slices/FaqsSlice";
import featuredvendorsReducer from "./slices/FeaturedvendorsSlice";
import vendorrecommendationsReducer from "./slices/VendorrecommendationsSlice";
import accountsReducer from "./slices/AccountsSlice";
import membersReducer from "./slices/MembersSlice";
import vendorsonhomeReducer from "./slices/VendorsonhomeSlice";
import rewardsReducer from "./slices/RewardsSlice";
import industry_sector_parentReducer from "./slices/Industry_sector_parentSlice";
import industry_sector_childReducer from "./slices/Industry_sector_childSlice";
import vendor_profile_update_requestsReducer from "./slices/Vendor_profile_update_requestsSlice";
import authReducer from "./slices/authSlice";
import memberReferralsReducer from "./slices/MemberReferralSlice";
import referralHistoryReducer from "./slices/referralHistorySlice";

export const store = configureStore({
  reducer: {
    default: defaultReducer,
    referrals: referralsReducer,
    vendor: vendorReducer,
    referralpayments: referralpaymentsReducer,
    disputes: disputesReducer,
    waitlist: waitlistReducer,
    faqs: faqsReducer,
    featuredvendors: featuredvendorsReducer,
    vendorrecommendations: vendorrecommendationsReducer,
    accounts: accountsReducer,
    members: membersReducer,
    vendorsonhome: vendorsonhomeReducer,
    rewards: rewardsReducer,
    industry_sector_parent: industry_sector_parentReducer,
    industry_sector_child: industry_sector_childReducer,
    vendor_profile_update_requests: vendor_profile_update_requestsReducer,
    auth: authReducer,
    memberReferrals: memberReferralsReducer,
    referralHistory: referralHistoryReducer,
  },
  middleware: (getDefault) => getDefault({ serializableCheck: false }),
});

export default store;
